<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">Milk ui</h1>
        <p id="role">UI library, Branding<br />2019</p>
      </div>

      <div class="desc">
        <p id="desc">
          <b>Description</b><br />
          개발과 디자인을 맡고 있는 각자의 이름인 Jeongwoo의 'Woo'와 Yuri의
          'Yu'를 합쳐 우유(Milk) UI 프로젝트를 진행하였다.<br />'Space',
          'Perspective', 'Fill'을 키워드로 하여 공간이 채워지는 콘셉트로
          작업하였다.
        </p>
        <p id="name">
          <b>Planning:</b> Yuri Ahn, Jeongwoo Ahn<br /><b>Design:</b> Yuri
          Ahn<br /><b>Front-end programming:</b> Jeongwoo Ahn<br /><br /><a
            style="color: #303133"
            href="https://woo-u.github.io/milkui/#/"
            target="_blank"
            >View UI Library</a
          >
        </p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/milk_ui/01.png" />
        <img src="/images/portfolios/milk_ui/02.png" />
        <img src="/images/portfolios/milk_ui/03.png" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('taste-of-book')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('alice')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "DetailMilkUi",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/milk_ui/top.svg");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  margin-top: -5px;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
